<template>
    <v-simple-table dense>
        <tbody>
            <tr>
                <th>Code</th>
                <td>{{ value ? value.code : null }}</td>
            </tr>
            <tr>
                <th>Name</th>
                <td>{{ value ? value.name : null }}</td>
            </tr>
            <tr>
                <th>Description</th>
                <td>{{ value ? value.description : null }}</td>
            </tr>
            <tr>
                <th>Type</th>
                <td>{{ value && value.type ? value.type.name : null }}</td>
            </tr>
            <tr>
                <th>Group</th>
                <td>{{ value && value.group ? value.group.display_name : null }}</td>
            </tr>
            <tr>
                <th>Measure Unit</th>
                <td>{{ value && value.measure_unit ? value.measure_unit.name : null }}</td>
            </tr>
        </tbody>
    </v-simple-table>
</template>

<script>
export default {
    name: "Item",
    props: {
        value: Object
    }
}
</script>

<style>

</style>